module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PersonalAchieveView.js"));
	}, "PersonalAchieveView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PersonalAchieveView!./src/pages/Promote/Achievement/PersonalAchieve/PersonalAchieveView.js
// module id = 1154
// module chunks = 431